<template>
    <div class="animated fadeIn">
        <b-row class="justify-content-center">
            <b-col xl="6" lg="8">
                <b-card>
                    <div slot="header">
                        Set Current Periode (bulan berjalan pembukuan)
                    </div>
                        <b-row>
                            <b-col cols="8">
                                <b-form-group label-cols=3  label="Current Periode" >
                                    <b-form-input v-model="model.monthaktif" readonly></b-form-input>                                        
                                </b-form-group>                                
                            </b-col>
                            <b-col cols="4">    
                                <b-input-group >
                                    <b-input-group-prepend><label>Current Periode No</label></b-input-group-prepend>
                                    <b-form-input v-model="model.periodaktif" readonly></b-form-input>                                        
                                </b-input-group>
                            </b-col>
                        </b-row>                      
                        <b-row>
                            <b-col cols="8">
                                <b-form-group label-cols=3  label="Set Periode To" >
                                    <vue-monthly-picker v-model="model.monthnext" dateFormat="MMMM YYYY" :monthLabels="monthLabels" @selected="onChangeMonth" ></vue-monthly-picker>
                                </b-form-group>                                
                            </b-col>
                            <b-col cols="4">    
                                <b-input-group >
                                    <b-input-group-prepend><label>Next Periode No.</label></b-input-group-prepend>
                                    <b-form-input v-model="model.periodnext" readonly></b-form-input>                                        
                                </b-input-group>
                            </b-col>
                        </b-row>                 
                        <b-row class="justify-content-center mt-2">
                            <button  class="btn btn-primary mr-1" @click="setPeriode()"><i class="fa fa-save"></i> Set Current Periode</button>
                            <button class="btn btn-danger mr-1" @click="close()" > <i class="fa fa-close"></i> Close </button>
                        </b-row>
                </b-card>
            </b-col>
        </b-row>
        <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       
    </div>
</template>

<style lang="scss">
      .input-group {
          .input-group-prepend {
              label {
                  width: 130px !important;
                  margin-right:5px;
              }
          }
      }
</style>
<script>
import VueMonthlyPicker from 'vue-monthly-picker';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import toastr from "mini-toastr";
import moment from 'moment';
import dropdown from "../../data/dropdown";
import periode from "../../apis/consolperiode";
toastr.init();

export default {
  components: {VueMonthlyPicker,Loading},
  data() {
    return {
      horizontal: true,
      isLoading:false,
      model:{tglnext:'', periodnext:'-'},
      monthLabels:dropdown.monthLabels
    };
  },    
  created: async function (){
     const curPeriode = await periode.get();
     var tglaktifconsol=moment(curPeriode.tglaktifconsol,'YYYY-MM-DD');
     var tglnext=moment(curPeriode.tglaktifconsol,'YYYY-MM-DD').add(1,'M');
     this.model.awalbln=curPeriode.awalbln;
    if (tglaktifconsol.get('month') < (this.model.awalbln - 1)) {
        this.model.periodaktif = tglaktifconsol.get('month') + 11;
    } else {
        this.model.periodaktif = tglaktifconsol.get('month') + 2 - this.model.awalbln;
    }
     this.model.monthaktif=tglaktifconsol.format('MMMM YYYY');
     this.model.tglaktifconsol=curPeriode.tglaktifconsol;
    this.$forceUpdate();
  },  
  methods: {
    onChangeMonth: async function (){
        var tglnext=this.model.monthnext;
        if (tglnext.get('month') < (this.model.awalbln - 1)) {
            this.model.periodnext = tglnext.get('month') + 11;
        } else {
            this.model.periodnext = tglnext.get('month') + 2 - this.model.awalbln;
        }
    },  
    async setPeriode(){
        try {
            if (this.model.monthnext) {
                this.isLoading=true;
                this.model.tglnext=this.model.monthnext.format('YYYY-MM-DD');
                console.log('this.model.tglnext : ',this.model.tglnext);

                let user = await periode.set(this.model);
                this.isLoading=false;    
                toastr.success("Complete successfully", "Closing Periode");
                // console.log(user);
                this.$store.commit("user",user);
                var tglaktifconsol=moment(user.tglaktifconsol,'YYYY-MM-DD');
                this.model.monthaktif=tglaktifconsol.format('MMMM YYYY');
                this.model.tglaktifconsol=user.tglaktifconsol;
                if (tglaktifconsol.get('month') < (this.model.awalbln - 1)){
                    this.model.periodaktif = tglaktifconsol.get('month') + 11;
                } else {
                    this.model.periodaktif = tglaktifconsol.get('month') + 2 - this.model.awalbln;
                }
                toastr.info("Current Periode has been Change ");
            }
        } catch (error) {
            this.isLoading=false;
            this.isLoading=false;
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }        
        }
    }, 
    close(){
      router.push("/accounting/home");
    }, 
  }
};
</script>